<div class="row">
    <div class="item first" translate [translateParams]="{ index: order }">
        questionBoard.edit.reply
    </div>
    <div class="item" *ngFor="let ans of   myAnswersSignal$()">
        <div>
            <p class="ans" [ngClass]="{ answerWasChange: showComparison$() && ans.answer?.wasChange }"> {{ ans.answer |
                answerSwitchType : ans.modularQuestion }}</p>
        </div>
    </div>
</div>